import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "mojikumitabledefaults"
    }}>{`MojikumiTableDefaults`}</h1>
    <p>{`Mojikumi table options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NOTHING`}</strong>{` = 1851876449`}</p>
      <p parentName="blockquote">{`Turns off mojikumi.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_END_ALL_ONE_HALF_EM_ENUM`}</strong>{` = 1246572593`}</p>
      <p parentName="blockquote">{`Uses half-width spacing for all characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_EM_INDENT_LINE_END_UKE_ONE_HALF_EM_ENUM`}</strong>{` = 1246572594`}</p>
      <p parentName="blockquote">{`Indents lines one space and uses line end uke one half space.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_OR_ONE_HALF_EM_INDENT_LINE_END_UKE_ONE_HALF_EM_ENUM`}</strong>{` = 1246572595`}</p>
      <p parentName="blockquote">{`Indents lines one full or half space and uses line end uke one half space.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_OR_ONE_HALF_EM_INDENT_LINE_END_ALL_ONE_EM_ENUM`}</strong>{` = 1246572596`}</p>
      <p parentName="blockquote">{`Uses full-witdh spacing for all characters except the last character in the line, which uses either full- or half-width spacing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_EM_INDENT_LINE_END_ALL_ONE_EM_ENUM`}</strong>{` = 1246572597`}</p>
      <p parentName="blockquote">{`Indents lines one full space and uses full-width spacing for all characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_EM_INDENT_LINE_END_ALL_NO_FLOAT_ENUM`}</strong>{` = 1246572598`}</p>
      <p parentName="blockquote">{`Indents lines one full space and uses no float for all characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_EM_INDENT_LINE_END_UKE_NO_FLOAT_ENUM`}</strong>{` = 1246572599`}</p>
      <p parentName="blockquote">{`Indents lines one full space and uses line end uke no float.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_OR_ONE_HALF_EM_INDENT_LINE_END_UKE_NO_FLOAT_ENUM`}</strong>{` = 1246572600`}</p>
      <p parentName="blockquote">{`Indents lines one half space or one full space and uses line end uke no float.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_EM_INDENT_LINE_END_ALL_ONE_HALF_EM_ENUM`}</strong>{` = 1246572601`}</p>
      <p parentName="blockquote">{`Indents lines one full space and uses half-width spacing for all characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_END_ALL_ONE_EM_ENUM`}</strong>{` = 1246572848`}</p>
      <p parentName="blockquote">{`Uses full-width spacing for all characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_END_UKE_NO_FLOAT_ENUM`}</strong>{` = 1246572849`}</p>
      <p parentName="blockquote">{`Uses line end uke no float.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_OR_ONE_HALF_EM_INDENT_LINE_END_PERIOD_ONE_EM_ENUM`}</strong>{` = 1246572850`}</p>
      <p parentName="blockquote">{`Indents lines one or one-half space and uses full-width spacing for punctuation and for the last character in the line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_EM_INDENT_LINE_END_PERIOD_ONE_EM_ENUM`}</strong>{` = 1246572851`}</p>
      <p parentName="blockquote">{`Indents lines one full space and uses full-width spacing for punctuation and for the last character in the line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_END_PERIOD_ONE_EM_ENUM`}</strong>{` = 1246572852`}</p>
      <p parentName="blockquote">{`Uses full-width spacing for punctuation.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRAD_CHINESE_DEFAULT`}</strong>{` = 1246572853`}</p>
      <p parentName="blockquote">{`Uses mojikumi tsume and aki optimized for Traditional Chinese centered punctuation glyphs.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SIMP_CHINESE_DEFAULT`}</strong>{` = 1246572854`}</p>
      <p parentName="blockquote">{`Uses mojikumi tsume and aki optimized for Simplified Chinese punctuation glyphs.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      